<template>
  <iframe
    :src="videoUrl"
    :allow="allowAttributes"
    class="w-full h-full"
  />
</template>

<script>
export default {
  props: {
    video: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    videoId () {
      const videoUri = new this.$uri(this.video)

      return videoUri.path().split('/')[2]
    },
    allowAttributes () {
      if (this.autoplay) return 'fullscreen autoplay'
      else return 'fullscreen'
    },
    videoUrl () {
      let url = 'https://player.vimeo.com/video/' + this.videoId

      return url
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/Videos/Vimeo.vue